import { apiInstances } from '../../../../../libs';

const { get } = apiInstances.orderInstance;

export default async function validateOrderByQR(idOrder) {
  return await get(`clouders/orders/${idOrder}/qr`);
}
